import { transformSearch } from "@/api/helper.ts";
import { queryClient } from "@/query-client.ts";
import { queryOptions, useMutation } from "@tanstack/react-query";
import { z } from "zod";
import siteService from "../services/site-service";

export const siteSearchSchema = z.object({
	search: z.string().optional(),
	include: z.string().optional(),
	page: z.number().nullable().optional(),
	per_page: z.number().optional(),
	status: z.string().optional(),
});

export const sitesQueryOptions = (search?: z.infer<typeof siteSearchSchema>, options?: { enabled: boolean }) => {
	return queryOptions({
		queryKey: ["sites", search],
		queryFn: () => siteService.list(transformSearch(search, ["search", "status"])),
		...options,
	});
};

export const siteQueryOptions = (siteId: string) => {
	return queryOptions({
		queryKey: ["site", siteId],
		queryFn: () => siteService.findById(siteId),
	});
};

export const useSiteCreateMutation = (siteId?: string) => {
	return useMutation({
		mutationKey: ["site", siteId],
		mutationFn: siteService.create,
		meta: {
			successMessage: "Site created successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["sites"] }),
	});
};

export const useSiteUpdateMutation = (siteId: string) => {
	return useMutation({
		mutationKey: ["site", siteId],
		mutationFn: (data: Record<string, unknown>) => siteService.upsert(data),
		meta: {
			successMessage: "Site updated successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["sites"] }),
	});
};

export const useSiteDeleteMutation = (id: string) => {
	return useMutation({
		mutationKey: ["site-delete"],
		mutationFn: siteService.deleteById(id),
		meta: {
			successMessage: "Site deleted successfully",
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ["sites"] }),
	});
};
